
import { useNavigate, useParams } from 'react-router-dom';
import '../App.css';
import { BackgroundStyle, BigHeading, FlexContainer, ListContainer, LongBlueButton, SearchingBoxContainer } from '../assets/style';
import MainContent from '../components/MainContent';
import { contractPageName } from '../components/PageName';
import SearchBox from '../components/SearchBox';
import SearchDatePicker from '../components/SearchDatePicker';
import SearchInput from '../components/SearchInput';
import RecordTable, { TableHeader } from '../components/RecordTable';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useLazyGetContractListQuery } from '../features/contract/ContractSlice';
import { RecordModel } from '../models/RecordModel';
import RecordTableV2 from '../components/RecordTableV2';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { selectPermissions } from '../features/auth/authSlice';
import { Permissions } from '../utils/Permissions';

const ContractListingPage = () => {
    const { t, i18n } = useTranslation();
    const [contractNumber, setContractNumber] = useState("")
    const [contractTitle, setContractTitle] = useState("")
    const [startDate, setStartDate] = useState(dayjs(null))//useState(dayjs().subtract(3, 'month'))
    const [endDate, setEndDate] = useState(dayjs(null))
    const [getContractList, contractList] = useLazyGetContractListQuery();
    const navigate = useNavigate()
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();
    const permissions = useSelector(selectPermissions)

    const columns: TableHeader[] = [
        { field: 'contractNumber', headerName: t('Contract No.'), width: 200, isSortable: true },
        { field: 'contractTitle', headerName: t('Contract Title'), width: 400, isSortable: false },
        { field: 'startDate', headerName: t('Start Date'), width: 200, isSortable: false },
        { field: 'endDate', headerName: t('End Date'), width: 200, isSortable: false },
        { field: 'remark', headerName: t('Remark'), width: 500, isSortable: false },
    ];

    const handleRowClick = function (row: any) {
        //console.log(row.contractId);
        navigate('/contract-detail', { state: row.id })
    }


    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getContractList(
            {
                ContractNo: contractNumber?.toString(),
                ContractName: contractTitle?.toString(),
                StartDate: startDate?.format("DD/MM/YYYY").toString(),
                EndDate: endDate?.format("DD/MM/YYYY").toString(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.id,
                contractNumber: item?.number,
                contractTitle: item?.title,
                projectNumber: item?.projectNumber,
                startDate: item?.startDate,
                endDate: item?.endDate,
                remark: item.remark
            }))
        }
        // return [];
    };


    const handleSearchClick = () => {
        try {
            getContractList({
                ContractNo: contractNumber?.toString(),
                ContractName: contractTitle?.toString(),
                StartDate: startDate?.format("DD/MM/YYYY").toString(),
                EndDate: endDate?.format("DD/MM/YYYY").toString()
            })
                .then(
                    (res) => {
                        if (res.status == 'fulfilled') {
                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.id,
                                contractNumber: item?.number,
                                contractTitle: item?.title,
                                projectNumber: item?.projectNumber,
                                startDate: item?.startDate,
                                endDate: item?.endDate,
                                remark: item.remark
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
        } catch (error) {

        }
    }

    useEffect(() => {
        handleSearchClick();
    }, [])
    return (
        <MainContent type={contractPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer>
                    <BigHeading>{t("Contract")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchInput title={t("Contract No.")} value={contractNumber} setMethod={setContractNumber} />
                                <SearchInput title={t("Contract Title")} value={contractTitle} setMethod={setContractTitle} />
                                {/* <SearchInput title={"Project Manager"} value={projectManager} setMethod={setProjectManager} /> */}
                                <SearchDatePicker title={t("Start Date")} value={startDate} setMethod={setStartDate} />
                                <SearchDatePicker title={t("End Date")} value={endDate} setMethod={setEndDate} />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton onClick={handleSearchClick}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                            {
                                permissions.includes(Permissions.ContractEdit) &&
                                <FlexContainer>
                                    <LongBlueButton onClick={() => { navigate('/add-contract') }}>{t("Add New Contract")}</LongBlueButton>
                                </FlexContainer>
                            }
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* <RecordTable getRowId={e => e.contractId} columns={columns} rows={rows} checkbox={true} onClick={handleRowClick}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                </ListContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default ContractListingPage;